import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)(({ theme }) => ({
  '& .DSSoldPrice': {
    textDecoration: 'line-through',
    opacity: 0.6,
  },
  '& .DSSmiddleborder': {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '20%',
      bottom: '20%',
      left: 0,
      width: '1px',
      backgroundColor: theme.palette.divider[7],
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '20%',
      bottom: '20%',
      right: 0,
      width: '1px',
      backgroundColor: theme.palette.divider[7],
    },
  },
  '& .DSHurreyText': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .DSHurreyIcon': {
      width: theme.spacing(2.75),
      height: theme.spacing(2.75),
      marginRight: theme.spacing(0.5),
      position: 'relative',
      top: theme.spacing(-0.25),
      color: theme.palette.primary.main,
    },
  },
  '& .CDCGetFree':{
    display:'block',
  },
  '&.DSSDisabled':{
    '& .MuiTypography-root':{
    color: theme.palette.text.disabled,
    },
     '& .DSHurreyIcon': {
      color:  theme.palette.text.disabled,
     }
  },
}));
